module.exports = __webpack_public_path__ + "img/Bucher & Zeitschriften.a84e99e9.jpg";